import { oc } from "@orpc/contract";
import { ScopePreviewsSchema } from "@packages/core/organization/scope.ts";

export { type ScopeMember, type ScopePreview, type ScopePreviews, PREVIEW_SIZE } from "@packages/core/organization/scope.ts";

export const scopeContract = {
    getPreviews: oc
        .route({ method: "GET", path: "/previews" })
        .errors({
            UPSTREAM_FAILURE: {}
        })
        .output(ScopePreviewsSchema)
};
